<template>
  <section class="lets-connect">
    <div class="container">
      <div class="row">
        <div class="contact-us-f g-form">
          <div class="page-title mb-4">
            <h2 class="d-hex-color fw-semibold mb-0 text-sm">
              Request a Private Event
            </h2>
            <p class="mt-2" style="line-height: 26px">
              Tell us your vision, and we'll help create a memorable cultural
              experience tailored to your group, organization, or company.
            </p>
            <p style="line-height: 26px"><span class="fw-bold" style="display: contents; ">Perfect for:</span> Corporate Events, Team Building, Conferences, Schools
              & Universities, Community Organizations, Private Celebrations</p>
          </div>
          <form ref="form" @submit.prevent="eventFormSubmit" novalidate>
            <span class="d-flex justify-content-between gap-4">
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">First Name*</label>
                <base-input
                  type="text"
                  v-model="formData.firstName"
                  custom-classes="w-100"
                  required
                  placeholder="First Name"
                />
                <span
                  v-if="errors.firstName"
                  class="text-danger text-sm mt-1"
                  >{{ errors.firstName }}</span
                >
              </span>
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Last Name*</label>
                <base-input
                  type="text"
                  v-model="formData.lastName"
                  custom-classes="w-100"
                  required
                  placeholder="Last Name"
                />
                <span v-if="errors.lastName" class="text-danger text-sm mt-1">{{
                  errors.lastName
                }}</span>
              </span>
            </span>
            <span class="d-flex justify-content-between">
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Business / Organization*</label>
                <base-input
                  type="text"
                  v-model="formData.business"
                  custom-classes="w-100"
                  required
                  placeholder="Business / Organization"
                />
                <span v-if="errors.business" class="text-danger text-sm mt-1">{{
                  errors.business
                }}</span>
              </span>
            </span>
            <span class="d-flex justify-content-between">
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Email Address*</label>
                <base-input
                  type="email"
                  v-model="formData.email"
                  custom-classes="w-100"
                  required
                  placeholder="Email Address"
                />
                <span v-if="errors.email" class="text-danger text-sm mt-1">{{
                  errors.email
                }}</span>
              </span>
            </span>
            <span class="d-flex justify-content-between gap-4">
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Approximate Date of the event</label>
                <input
                  type="date"
                  v-model="formData.eventDate"
                  :min="minDate"
                />
              </span>
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Approximate Time of the event</label>
                <input type="time" v-model="formData.eventTime" />
              </span>
            </span>
            <span class="d-flex justify-content-between">
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Estimated Number of Guests</label>
                <base-input
                  type="number"
                  v-model="formData.guestCount"
                  custom-classes="w-100"
                  min="1"
                  step="1"
                  @keydown="blockInvalidNumberKey"
                  @paste="blockInvalidNumberPaste"
                  placeholder="Estimated Number of Guests"
                />
              </span>
            </span>
            <span class="d-flex justify-content-between">
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Budget Range</label>
                <base-select v-model="formData.budgetRangeLabel" :options="budgetRangeLabels" custom-classes="w-100" />
              </span>
            </span>
            <span class="d-flex justify-content-between">
              <span class="g-input d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2">Preferred Cultural Experience</label>
                <base-input
                  type="text"
                  v-model="formData.culturalExperience"
                  custom-classes="w-100"
                  placeholder="Preferred Cultural Experience"
                />
              </span>
            </span>
            <span class="field-checkbox">
              <div class="field-checkbox-col">
                <label class="mb-2"
                  >What type of event are you interested in?</label
                >
                <div>
                  <ul class="flex flex-wrap">
                    <li class="choice-2 me-5 pe-2 flex">
                      <input
                        type="checkbox"
                        v-model="formData.interestedEvent"
                        id="private-event-checkbox2"
                        value="Training Experience"
                      />
                      <label
                        for="private-event-checkbox2"
                        class="text-icon__color text-sm lg__mobile:text-xs ps-1"
                        >Training Experience</label
                      >
                      <router-link
                        :to="{
                          name: ROUTES.CORPORATION_DEI,
                        }"
                        ><svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="ms-2"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07L11 4"
                          />
                          <path
                            d="M14 11a5 5 0 0 0-7.07 0L4.1 13.83a5 5 0 0 0 7.07 7.07L13 20"
                          /></svg
                      ></router-link>
                    </li>
                    <li class="choice-1 me-5 pe-2 flex">
                      <input
                        type="checkbox"
                        v-model="formData.interestedEvent"
                        id="private-event-checkbox1"
                        value="American Explorer"
                      />
                      <label
                        for="private-event-checkbox1"
                        class="text-icon__color text-sm lg__mobile:text-xs ps-1"
                        >American Explorer</label
                      >
                      <router-link
                        :to="{
                          name: ROUTES.AMERICAN_EXPLORER,
                        }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="ms-2"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07L11 4"
                          />
                          <path
                            d="M14 11a5 5 0 0 0-7.07 0L4.1 13.83a5 5 0 0 0 7.07 7.07L13 20"
                          />
                        </svg>
                      </router-link>
                    </li>
                    <li class="choice-3 me-5 pe-2 flex">
                      <input
                        type="checkbox"
                        v-model="formData.interestedEvent"
                        id="private-event-checkbox3"
                        value="Other"
                      />
                      <label
                        for="private-event-checkbox3"
                        class="text-icon__color text-sm lg__mobile:text-xs ps-1"
                        >Other</label
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </span>
            <span class="d-flex justify-content-between mt-4">
              <span class="g-input textarea d-flex flex-column mb-3 pb-1 w-100">
                <label class="mb-2"
                  >Description of your goals or any additional details:</label
                >
                <base-textarea
                  :rows="3"
                  v-model="formData.description"
                  custom-classes="w-100"
                  placeholder="Any specific celebration or theme."
                />
              </span>
            </span>
            <span class="pt-3 g-btn text-end">
              <button type="submit" class="f-g-btn primary-bg text-white p-3">
                Submit
              </button>
            </span>
          </form>
          <api-response
            v-if="successMessage"
            error-type="success"
            custom-classes="mb-4 mt-4"
            :message="successMessage"
          />
          <api-response
            v-if="errorMessage"
            error-type="error"
            custom-classes="mb-4 mt-4"
            :message="errorMessage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive, ref, watch } from "vue";
import BaseTextarea from "@/components/common/form/base-textarea";
import BaseInput from "@/components/common/form/base-input";
import BaseSelect from "@/components/common/form/base-select";
import usePrivateEventService from "@/services/private-event.service";
import ApiResponse from "@/components/common/text/api-response";
import { VALIDATION_MESSAGE_TIMEOUT, PRIVATE_EVENT_BUDGET_RANGES } from "@/utils/constants";
import { ROUTES } from "@/utils/constants/routes";

const budgetRangeLabels = PRIVATE_EVENT_BUDGET_RANGES.map((range) => range.label);

const { useHandlePrivateEventFormService } = usePrivateEventService();
const { mutate } = useHandlePrivateEventFormService();

const minDate = new Date().toISOString().split("T")[0];

const formData = reactive({
  firstName: "",
  lastName: "",
  business: "",
  email: "",
  eventDate: "",
  eventTime: "",
  interestedEvent: [],
  guestCount: "",
  budgetRangeLabel: "",
  culturalExperience: "",
  description: "",
});

const errors = reactive({
  firstName: "",
  lastName: "",
  business: "",
  email: "",
});

watch(
  () => formData.firstName,
  (value) => {
    if (value) errors.firstName = "";
  },
);
watch(
  () => formData.lastName,
  (value) => {
    if (value) errors.lastName = "";
  },
);
watch(
  () => formData.business,
  (value) => {
    if (value) errors.business = "";
  },
);
watch(
  () => formData.email,
  (value) => {
    if (value) errors.email = "";
  },
);

const blockInvalidNumberKey = (event) => {
  if (["-", "+", "e", "E", "."].includes(event.key)) {
    event.preventDefault();
  }
};

const blockInvalidNumberPaste = (event) => {
  const pasted = (event.clipboardData || window.clipboardData).getData("text");
  if (!/^\d+$/.test(pasted)) {
    event.preventDefault();
  }
};

const sanitizeWholeNumber = (value) => {
  if (value === "" || value === null || value === undefined) return value;
  const digitsOnly = String(value).replace(/[^0-9]/g, "");
  if (digitsOnly === "") return "";
  const num = Number(digitsOnly);
  return num > 0 ? String(num) : "";
};

watch(
  () => formData.guestCount,
  (value) => {
    const sanitized = sanitizeWholeNumber(value);
    if (sanitized !== value) formData.guestCount = sanitized;
  },
);

const errorMessage = ref("");
const successMessage = ref("");

const validateForm = () => {
  errors.firstName = formData.firstName ? "" : "First Name is required.";
  errors.lastName = formData.lastName ? "" : "Last Name is required.";
  errors.business = formData.business
    ? ""
    : "Business / Organization is required.";
  errors.email = formData.email ? "" : "Email Address is required.";

  return (
    !errors.firstName && !errors.lastName && !errors.business && !errors.email
  );
};

const eventFormSubmit = () => {
  if (!validateForm()) {
    return;
  }

  formData.guestCount = sanitizeWholeNumber(formData.guestCount);
  const selectedRange = PRIVATE_EVENT_BUDGET_RANGES.find((range) => range.label === formData.budgetRangeLabel);

  const payload = {
    ...formData,
    budgetRangeMin: selectedRange ? selectedRange.min : "",
    budgetRangeMax: selectedRange ? selectedRange.max : "",
  };
  delete payload.budgetRangeLabel;

  mutate(payload, {
    onSuccess: (success) => {
      showResponseMessage("Form Submitted Successfully", "");
      formData.firstName = "";
      formData.lastName = "";
      formData.business = "";
      formData.email = "";
      formData.eventDate = "";
      formData.eventTime = "";
      formData.interestedEvent = [];
      formData.guestCount = "";
      formData.budgetRangeLabel = "";
      formData.culturalExperience = "";
      formData.description = "";
    },
    onError: (error) => {
      showResponseMessage(
        "",
        "We couldn't submit your request. Please check the details you entered and try again.",
      );
    },
  });
};

const showResponseMessage = (successMsg, errorMsg) => {
  if (successMsg != "") {
    errorMessage.value = "";
    successMessage.value = successMsg;
  } else if (errorMsg != "") {
    errorMessage.value = errorMsg;
    successMessage.value = "";
  }

  setTimeout(() => {
    errorMessage.value = "";
    successMessage.value = "";
  }, VALIDATION_MESSAGE_TIMEOUT);
};
</script>

<style scoped>
.field-checkbox-col > label {
  color: #4e4e4e;
  font-size: 14px;
}
.field-checkbox-col .text-icon__color {
  color: #4e4e4e !important;
}
.lets-connect .page-title h2 {
  font-size: 25.08px;
  line-height: 30px;
}
.lets-connect .contact-us-f.g-form {
  width: 100%;
  max-width: 700px;
  margin-left: auto;
  margin-right: 0;
  padding: 40px;
}
@media (max-width: 1199px) {
  .lets-connect .row {
    justify-content: center;
  }
  .lets-connect .contact-us-f.g-form {
    margin-right: auto;
  }
}
</style>
